type Prop = {
  isProxy: boolean;
};

type TargetObject = {
  [key: string]: unknown;
  propname?: unknown;
};

export const stateProxyHandler = {
  get(target: TargetObject, key: string): unknown {
    const prop: Prop | unknown = target[key];
    if (typeof prop === 'undefined' || prop === null) {
      return;
    }

    // nested object proxy
    if (typeof prop === 'object' && !('isProxy' in prop && prop.isProxy)) {
      return new Proxy(prop, stateProxyHandler);
    }
    return prop;
  },

  set(target: TargetObject, key: string, value: unknown) {
    if (value !== target[key]) {
      this.setValue = true;
    }
    target[key] = value;

    // mark this object as modified
    //  this is just a cloned object and not the original target
    Object.assign(target, {__updated: true});
    return true;
  },
  setValue: false, // flag if any value has changed
};
